import { render, staticRenderFns } from "./Signup-Teacher-2Step-New.vue?vue&type=template&id=448d49ba"
import script from "./Signup-Teacher-2Step-New.vue?vue&type=script&lang=js"
export * from "./Signup-Teacher-2Step-New.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports